import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, onUnmounted, Ref, ref } from "vue";
import CiButton from "@components/base/button.vue";
import Scrollable from "@components/base/scrollable.vue";
import NotificationsList from "@components/notifications/list.vue";
import { useNotifications } from "@composables/notifications";
import { viewportService } from "@services/viewport.service";
import { CurrentUser } from "@utils/user";
import { debounce } from "throttle-debounce";


export default /*#__PURE__*/_defineComponent({
  __name: 'notifications',
  emits: ["tracking-click"],
  setup(__props, { emit }: { emit: ({ (event: "tracking-click", options: InternalTracking.TrackClickOptions): void }), expose: any, slots: any, attrs: any }) {

const { popup } = useNotifications();

const startPageNotifications: Ref<Nullable<HTMLDivElement>> = ref(null);
const startPageNotificationsContainer: Ref<Nullable<typeof Scrollable>> = ref(null);
const loading = computed(() => popup.loading.value);
const list = computed(() => popup.data.value);



const resizeNotificationsContainer = () => {
  // only the desktop view as a sized scroll element
  if (
    viewportService.check(["xl", "xxl"]) &&
    startPageNotifications.value?.clientHeight &&
    startPageNotificationsContainer.value
  ) {
    // unset to reset the parent elements clientHeight
    startPageNotificationsContainer.value.container.style.height = null;
    // 214.4 is the height of the header and the footer
    const containerHeight = startPageNotifications.value.clientHeight - 214.4;
    startPageNotificationsContainer.value.container.style.height = `${containerHeight}px`;
  }
};

onMounted(async () => {
  if (CurrentUser.signedIn) await popup.fetch();
  window.addEventListener("resize", debounce(100, resizeNotificationsContainer));
  resizeNotificationsContainer();
});

onUnmounted(() => window.removeEventListener("resize", debounce(100, resizeNotificationsContainer)));

return { __sfc: true,popup, startPageNotifications, startPageNotificationsContainer, loading, list, emit, resizeNotificationsContainer, CiButton, Scrollable, NotificationsList }
}

})